import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as DocumentImagePlusIconSvg } from '../../assets/document-image-plus-icon.svg';

export const DocumentImagePlusIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocumentImagePlusIconSvg} {...props} />;
};
